// extracted by mini-css-extract-plugin
export var addressFields = "_ph-0";
export var animationContainer = "_ph-1";
export var footer = "_ph-2";
export var lineItems = "_ph-3";
export var modalContent = "_ph-4";
export var orderName = "_ph-5";
export var strong = "_ph-6";
export var warning = "_ph-7";